import { z } from "zod";

import {
  ExperienceDtoSchema,
  PatchExperienceDtoSchema,
} from "../../../dtos/experiences";

export const PatchExperienceRequestPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});

export type PatchExperienceRequestPathParamType = z.infer<
  typeof PatchExperienceRequestPathParamSchema
>;

export const PatchExperienceRequestBodySchema = PatchExperienceDtoSchema;

export type PatchExperienceRequestBodyType = z.infer<
  typeof PatchExperienceRequestBodySchema
>;

export const PatchExperienceResponseBodySchema = z.object({
  experience: ExperienceDtoSchema,
});

export type PatchExperienceResponseBodyType = z.infer<
  typeof PatchExperienceResponseBodySchema
>;
